import Dropdown from '@cartwhl/ui/atoms/Dropdown';
import PlusIcon from '@cartwhl/ui/icons/PlusIcon';
import Button from '@cartwhl/ui/input/Button';

export interface BatchReferenceAddMenuProps {
  onAddFromLibrary: () => void;
  onAddFromComputer: () => void;
  layout?: 'footer' | 'floating';
}

export default function BatchReferenceAddMenu({
  onAddFromLibrary,
  onAddFromComputer,
  layout = 'footer',
}: BatchReferenceAddMenuProps) {
  return (
    <div
      className={
        layout === 'footer' ? 'flex items-center justify-end px-4 py-3' : ''
      }
    >
      <Dropdown
        align="end"
        trigger={
          <Button
            variant="secondary"
            size="sm"
            icon={<PlusIcon className="h-4 w-4" />}
            onClick={(event) => event.stopPropagation()}
          >
            Add
          </Button>
        }
      >
        <Dropdown.Item onClick={onAddFromLibrary}>
          From your Library
        </Dropdown.Item>
        <Dropdown.Item onClick={onAddFromComputer}>
          From your computer
        </Dropdown.Item>
      </Dropdown>
    </div>
  );
}
